<template xmlns:v-on="http://www.w3.org/1999/xhtml">
<div>
  <headlink></headlink>
  <div class="container ui-flex ui-flex-pack-center">

    <div class="right-container ui-center 	" >
      <div class="input-container" >
        <div>
          <input v-model="userName" class="input-pwd input" placeholder="请输入小于10位的字母用户名"/>
        </div>
        <div>
          <input type="password" v-model="pwd" class="input-pwd input" placeholder="请输入6位数字密码"/>
        </div>
        <div>
          <input type="password" v-model="pwd1" class="input-pwd input" placeholder="请确认密码"/>
        </div>
        <!--<div class="error" style="text-align: center;" >
          {{error}}
        </div>-->
        <button class="button-sure pointer"  v-on:click="addUser()">
          确认
        </button>
      </div>
    </div>
  </div>
</div>
</template>

<script>
import headlink from '@/components/common/headlink'

export default {
  name: 'addUser',
  data () {
    return {
      userName:"",
      pwd:"",
      pwd1:"",
      error:""
    }
  },
  methods:{
    addUser:function(){
      if(this.userName == ""){
       jeBox.msg('请输入用户名！', {icon: 3,time:1});
        return;
      }
      if(this.pwd == ""){
        jeBox.msg('请输入密码！', {icon: 3,time:1});
        return;
      }
      if(this.pwd.length < 6){
        jeBox.msg('密码长度过小！', {icon: 3,time:1});
        return;
      }
      if(this.pwd1 == ""){
       jeBox.msg('请确认密码！', {icon: 3,time:1});
        return;
      }
      if(this.pwd != this.pwd1){
        jeBox.msg('两次密码不一致！', {icon: 3,time:1});
        return;
      }
      const history = window.sessionStorage;
      var uid = history.getItem("user");
      this.$http.post('/ZYun/HttpService.do', {
        "serviceCode":"1004",
        "parentId":uid,
        "userName":this.userName,
        "userPwd":this.pwd,
        "userPwd2":this.pwd1
      })
        .then((response) => {
          if(response.data.respCode=="0000"){
            this.$router.push("/userManage");

          }else{
            this.error = response.data.respMsg;
            console.log(response);
          }
        })
        .catch((response) =>{
           this.error = response.data.respMsg;
          console.log(response);
        });
    }

  },
  mounted: function () {
    const history = window.sessionStorage;
    var uid = history.getItem("user");
    this.$http.post('/ZYun/HttpService.do', {
      "serviceCode":"1022",
      "parentId":uid
    })
      .then((response) => {
        if(response.data.respCode=="0000"){
          console.log(response)
          this.userList = response.data.userList;
        }else{
          console.log(response);
        }
      })
      .catch((response) =>{
        console.log(response);
      });
  },
  components: {
    headlink:headlink
  }
}

</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped src="../../../static/css/index.css" >
</style>



// WEBPACK FOOTER //
// src/components/userManage/addUser.vue